import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "antd";

import Table from "../../components/document/table";
import Header from "../../components/document/header";
import { handleError } from "../../modules/errorLogger";
import { checkHttpStatus, get } from "../../modules/httpFunctions";

export default function DocumentList() {
  const [documents, setDocuments] = useState();
  const handleDocumentsLoad = useCallback(() => {
    get("document")
      .then((r) => {
        setDocuments(
          checkHttpStatus(r) ? r.data.map((d, i) => ({ ...d, key: i })) : "e"
        );
      })
      .catch((err) => {
        setDocuments("e");
        handleError(err);
      });
  }, []);

  useEffect(() => {
    handleDocumentsLoad();
  }, [handleDocumentsLoad]);

  return (
    <Row>
      <Col>
        <Header />
        <Row type="flex" gutter={[0, 40]}>
          <Table documents={documents} onLoadDocuments={handleDocumentsLoad} />
          <Table
            processed
            documents={documents}
            onLoadDocuments={handleDocumentsLoad}
          />
        </Row>
      </Col>
    </Row>
  );
}
